import { ResourceClient } from 'clients/ResourceClient';
import { StringIndexModel, StringIndexModelProps } from 'models/StringIndexModel';

export abstract class StringIndexResourceClient<
  T extends StringIndexModel<P>,
  P extends StringIndexModelProps
> extends ResourceClient<T, P, string> {}
